var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Home',
          path: '/Home',
          icon: '',
        }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Venue',
            path: '/Venue',
            icon: ''
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Key Dates',
              path: '/KeyDates',
              icon: ''
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Call for Papers',
              path: '/CallForPapers',
              icon: ''
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Paper Submission',
                path: '/PaperSubmission',
                icon: ''
              }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Committees',
                  path: '/Committees',
                  icon: ''
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Registration',
                  path: '/Registration',
                  icon: ''
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Program',
                  path: '/Program',
                  icon: ''
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'AboutIDASB',
                  path: '/AboutIDASB',
                  icon: ''
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Contact',
                  path: '/Contact',
                  icon: ''
                }}})],1),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"})])],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }